<template>
	<div class="col-lg-8">
		<div class="activity-list ">
			<div class="activity-item text-block" v-if="notFound">
				Справочник не найден
			</div>

			<div class="activity-item text-block">
				<div>
					<RouterLink :to="`${basePath}/directories`">
						Справочники
					</RouterLink>
				</div>
				<div>
					<h4>{{name}}</h4>
				</div>
				<table class="table table-striped">
					<tr>
						<th v-for="field in fields" :key="field.key">{{ field.name }}</th>
					</tr>
					<tr v-for="item in data" :key="item.id">
						<td v-for="field in fields" :key="field.key">
							{{ item[field.key]?.name ?? item[field.key]?.full_name ?? item[field.key] }}
						</td>
					</tr>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import { getDataJson, urls } from '@/api/getData'
import pages from './directories'
import { getConfig } from '@/auth';

export default {
	data() {
		return {
			name: '',
			data: [],
			notFound: false,
			page: {},
			fields: [],
			basePath: getConfig().basePath
		}
	},
	created() {
		this.page = pages.find(x => x.path === this.$route.params.name)
		if (this.page) {
			this.name = this.page.name
			getDataJson(urls[this.page.path]).then(x => {
				this.data = x.data

				if (this.page.fields) {
					this.fields = this.page.fields
				} else {
					let fields = []
					let el = x.data?.[0] ?? {}

					for (let key in el) {
						fields.push({ name: key, key })
					}

					this.fields = fields
				}
			})
		}
		else {
			this.notFound = true
		}
	},
}
</script>